import React from 'react'
import { Form, Icon, Input, Button, Row, Col } from 'antd';

export const ValidationFormStep4 = (props) => {
    if (props.currentStep !== 'Step 4') {
      return null
    }
    return(
      <div className="form-group">


            <h3 style={{ display: 'inline-block !important' }}>Confirmation - Validation has been recorded!</h3>

            <h4 style={{ display: 'inline-block !important' }}>Site ID: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.siteID}</span></h4>
            <h4 style={{  display: 'inline-block !important' }}>User ID: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.userID}</span></h4>
            <h4 style={{  display: 'inline-block !important' }}>Subject ID: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.subjectID}</span></h4>

            <div className="validation-exists">
                <hr />
                <p> </p>
                <h3 style={{  display: 'inline-block !important' }}>Validation Information</h3>

                <h4 style={{  display: 'inline-block !important' }}>Validation Date: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.validationExistsDate}</span></h4>
                <h4 style={{  display: 'inline-block !important' }}>Drug allocated as per randomization administered: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>
                    {props.validationExistsUsedRecommendedValues === true ? <div>Yes</div> : <div>No</div> }
                </span></h4>

                <div>
                    <h4 style={{  display: 'inline-block !important' }}>Validation Weight: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.validationExistsWeight} kg</span></h4>

                    <h4 style={{  display: 'inline-block !important' }}>Validation Drug: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.validationExistsGroup === 'tpa' ? 'Alteplase tPA' : 'Tenecteplase tNK'}</span></h4>
                    {props.validationExistsGroup === 'tnk_tpa' ?
                        <h4 style={{ marginTop: '2rem', display: 'inline-block !important' }}>Validation Dose: <h2 style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.validationExistsTNKDose}</h2></h4>
                        :
                        <div>
                            <h4 style={{ marginTop: '2rem', display: 'inline-block !important' }}>Validation Bolus Dose: <h2 style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.validationExistsTPABolusDose}</h2></h4>
                            <h4 style={{ marginTop: '2rem', display: 'inline-block !important' }}>Validation Infusion Dose: <h2 style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.validationExistsTPAInfusionDose}</h2></h4>
                        </div>
                    }
                </div>

                <h4 style={{  display: 'inline-block !important' }}>Validation Comments: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.validationExistsComments}</span></h4>

                <hr />
                <p> </p>
                <h3 style={{  display: 'inline-block !important' }}>Deviation Details</h3>
                <h4 style={{  display: 'inline-block !important' }}>Any other protocol deviation(s) occurred: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>
                    {props.validationExistsDeviationOccurred === true ? <div>Yes</div> : <div>No</div> }
                </span></h4>
                {props.validationExistsDeviationOccurred === true ?
                    <h4 style={{  display: 'inline-block !important' }}>Deviation Comments: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.validationDeviationExistsComments}</span></h4>
                    : null }

                <hr />
                <p> </p>
                <h3 style={{  display: 'inline-block !important' }}>Vial Information</h3>

                <h4 style={{  display: 'inline-block !important' }}>Vial Number: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.validationExistsVialNumber}</span></h4>
                <h4 style={{  display: 'inline-block !important' }}>Vial Expiry Date: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.validationExistsVialExpiryDate}</span></h4>

                <hr />
                <br/>
                <h3 style={{  display: 'inline-block !important' }}>SAE Information</h3>

                <h4 style={{  display: 'inline-block !important' }}>SAE exists: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.saeExists === true ? 'Yes' : props.saeExists === false ? 'No' : 'Not entered'}</span></h4>
            </div>

      </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/ValidateRandomization/Step4.js